import smsReducer from './smsReducer';

export default smsReducer;